import React from "react";
import { DataGrid } from "@mui/x-data-grid";

const columns = [
    {
        field: 'surname',
        headerName: 'Last name',
        width: 150
    },
    {
        field: 'givenName',
        headerName: 'First name',
        width: 150
    },
    {
        field: 'mail',
        headerName: 'Email',
        width: 250,
        renderCell: (params) => (
            params.value == null ? <></> :
                <a href={'mailto:' + params.value}>
                    {params.value}
                </a>
        )
    },
    {
        field: 'jobTitle',
        headerName: 'Job title',
        width: 200
    },
    {
        field: 'displayName',
        headerName: 'Display name',
        width: 200
    },
    {
        field: 'phones',
        headerName: 'Phones',
        width: 200,
        valueGetter: (params) => [...new Set([...params.row.businessPhones, params.row.mobilePhone])].join(',')
    }
]

export const DirectoryData = ({ directoryData }) => {
    const rows = directoryData.value.filter(
        p => !(p.jobTitle != null
            && p.jobTitle.toString().includes("SystemAccount"))
    );
    return (
        <DataGrid
            className="directoryData"
            rows={rows}
            columns={columns}
            pageSize={100}
            rowsPerPageOptions={[10, 30, 100, 1000]}
            autoHeight
        />
    );
};
